import { createActions, createReducer } from 'reduxsauce'

import TipoNaturezaObraService from '../servicos/TipoNaturezaObraService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaNaturezaInicio: [],
    buscaNaturezaSucesso: ['tipo'],
    buscaNaturezaErro: ['erro'],
    limpar: [],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaNatureza = filtro => {
    return dispatch => {
        dispatch(Creators.buscaNaturezaInicio())
        let serv = new TipoNaturezaObraService()
        return serv
            .getTipoNaturezaObra()
            .then(response => dispatch(Creators.buscaNaturezaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaNaturezaErro(error)))
    }
}

const buscaNaturezaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaNaturezaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaNaturezaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipo, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_NATUREZA_INICIO]: buscaNaturezaInicio,
    [Types.BUSCA_NATUREZA_ERRO]: buscaNaturezaErro,
    [Types.BUSCA_NATUREZA_SUCESSO]: buscaNaturezaSucesso,
    [Types.LIMPAR]: limpar,
})
